import axios from '../../helpers/interceptors';
import {setAuthorizationStatus} from "../main/action";

import {
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_FAILURE,
    GET_EVENTS_STARTED,
    GET_EVENTS_SUCCESS,
    GET_EVENTS_FAILURE,
    CHOICE_EVENT_STARTED,
    CHOICE_EVENT_SUCCESS,
    CHOICE_EVENT_FAILURE,
    GET_CABINET_MAIN_DATA_STARTED,
    GET_CABINET_MAIN_DATA_SUCCESS,
    GET_CABINET_MAIN_DATA_FAILURE,
    GET_CURRENT_EVENT_STARTED,
    GET_CURRENT_EVENT_SUCCESS,
    GET_CURRENT_EVENT_FAILURE,
    SET_MOBILE_NAV_STATUS,
    GET_ROADMAP_STARTED,
    GET_ROADMAP_SUCCESS,
    GET_ROADMAP_FAILURE,
    GET_LEADERBOARD_STARTED,
    GET_LEADERBOARD_SUCCESS,
    GET_LEADERBOARD_FAILURE,
    GET_MATRIX_STARTED,
    GET_MATRIX_SUCCESS,
    GET_MATRIX_FAILURE,
    GET_REFERRALS_STARTED,
    GET_REFERRALS_SUCCESS,
    GET_REFERRALS_FAILURE,
    GET_REFERRALS_MAIN_STARTED,
    GET_REFERRALS_MAIN_SUCCESS,
    GET_REFERRALS_MAIN_FAILURE,
    SET_MATRIX_SELL_WARNING_MODAL_STATUS,
    SET_MATRIX_SELL_SUCCESS_MODAL_STATUS,
    SET_MATRIX_SELL_MODAL_STATUS,
    SET_MATRIX_BUY_MODAL_STATUS,
    GET_CONTEST_WINNERS_STARTED,
    GET_CONTEST_WINNERS_SUCCESS,
    GET_CONTEST_WINNERS_FAILURE,
    GET_CONTEST_WINNERS_DATA_STARTED,
    GET_CONTEST_WINNERS_DATA_SUCCESS,
    GET_CONTEST_WINNERS_DATA_FAILURE,
    SET_REF_CODE_STARTED,
    SET_REF_CODE_SUCCESS,
    SET_REF_CODE_FAILURE,
    SEND_CONNECTED_WALLET_STARTED,
    SEND_CONNECTED_WALLET_SUCCESS,
    SEND_CONNECTED_WALLET_FAILURE,
    GET_TOKEN_COURSE_STARTED,
    GET_TOKEN_COURSE_SUCCESS,
    GET_TOKEN_COURSE_FAILURE,
    SEND_WALLET_AFTER_TRANSACTION_STARTED,
    SEND_WALLET_AFTER_TRANSACTION_SUCCESS,
    SEND_WALLET_AFTER_TRANSACTION_FAILURE,
    SET_MATRIX_BUY_QR_MODAL_STATUS,
    GET_RECEIVE_USDT_WALLET_STARTED,
    GET_RECEIVE_USDT_WALLET_SUCCESS,
    GET_RECEIVE_USDT_WALLET_FAILURE,
    GET_CONTEST_INFO_STARTED,
    GET_CONTEST_INFO_SUCCESS,
    GET_CONTEST_INFO_FAILURE,
    SET_SETTINGS_AVATAR_MODAL_STATUS,
    CHANGE_PASSWORD_STARTED,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    CHANGE_AVATAR_STARTED,
    CHANGE_AVATAR_SUCCESS,
    CHANGE_AVATAR_FAILURE,
    GET_TRANSACTIONS_STARTED,
    GET_TRANSACTIONS_SUCCESS,
    GET_TRANSACTIONS_FAILURE,
    SET_BUY_REQUEST_STARTED,
    SET_BUY_REQUEST_SUCCESS,
    SET_BUY_REQUEST_FAILURE,
    SET_BUY_REQUEST_CONFIRM_STARTED,
    SET_BUY_REQUEST_CONFIRM_SUCCESS,
    SET_BUY_REQUEST_CONFIRM_FAILURE,
    SET_BUY_REQUEST_CANCEL_STARTED,
    SET_BUY_REQUEST_CANCEL_SUCCESS,
    SET_BUY_REQUEST_CANCEL_FAILURE,
    SET_WALLET_BUY_MODAL_STATUS,
    SET_GOOGLE_AUTHENTICATOR_MODAL_STATUS,
    SET_GOOGLE_AUTHENTICATOR_CONNECT_MODAL_STATUS,
    GET_DEPOSIT_LINK_STARTED,
    GET_DEPOSIT_LINK_SUCCESS,
    GET_DEPOSIT_LINK_FAILURE,
    GET_GOOGLE_CONNECT_QR_STARTED,
    GET_GOOGLE_CONNECT_QR_SUCCESS,
    GET_GOOGLE_CONNECT_QR_FAILURE,
    SET_GOOGLE_CODE_STARTED,
    SET_GOOGLE_CODE_SUCCESS,
    SET_GOOGLE_CODE_FAILURE,
    SELL_TOKENS_STARTED,
    SELL_TOKENS_SUCCESS,
    SELL_TOKENS_FAILURE,
    WITHDRAW_STARTED,
    WITHDRAW_SUCCESS,
    WITHDRAW_FAILURE,
    GET_WALLET_HISTORY_STARTED,
    GET_WALLET_HISTORY_SUCCESS,
    GET_WALLET_HISTORY_FAILURE,
    SET_REFERRAL_MODAL_STATUS,
    GET_REFERRAL_AWARDS_STARTED,
    GET_REFERRAL_AWARDS_SUCCESS,
    GET_REFERRAL_AWARDS_FAILURE,
    RESET_REFERRALS,
    GET_RESET_CODE_STARTED,
    GET_RESET_CODE_SUCCESS,
    GET_RESET_CODE_FAILURE
} from "./types";

import {api} from "../../api";
// // import {setAuthorizationStatus} from "../main/action";
// import {toast} from "react-toastify";
// import {t} from "i18next";
const host = api.host;
//
const headWT = ()=>{
    const token = localStorage.getItem('ftf-token');
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
}

export const setMatrixSellWarningModalStatus = status => ({
    type: SET_MATRIX_SELL_WARNING_MODAL_STATUS,
    payload: status
});

export const setMatrixSellSuccessModalStatus = status => ({
    type: SET_MATRIX_SELL_SUCCESS_MODAL_STATUS,
    payload: status
});

export const setMatrixSellModalStatus = status => ({
    type: SET_MATRIX_SELL_MODAL_STATUS,
    payload: status
});

export const setReferralModalStatus = status => ({
    type: SET_REFERRAL_MODAL_STATUS,
    payload: status
});

export const setWalletBuyModalStatus = status => ({
    type: SET_WALLET_BUY_MODAL_STATUS,
    payload: status
});

export const setMatrixBuyModalStatus = status => ({
    type: SET_MATRIX_BUY_MODAL_STATUS,
    payload: status
});

export const setMatrixBuyQrModalStatus = status => ({
    type: SET_MATRIX_BUY_QR_MODAL_STATUS,
    payload: status
});

export const setSettingsAvatarModalStatus = status => ({
    type: SET_SETTINGS_AVATAR_MODAL_STATUS,
    payload: status
});

export const setGoogleAuthenticatorModalStatus = status => ({
    type: SET_GOOGLE_AUTHENTICATOR_MODAL_STATUS,
    payload: status
});

export const setGoogleAuthenticatorConnectModalStatus = status => ({
    type: SET_GOOGLE_AUTHENTICATOR_CONNECT_MODAL_STATUS,
    payload: status
});

export const setMobileNavStatus = status => ({
    type: SET_MOBILE_NAV_STATUS,
    payload: status
});

export const cabinetLogout = () => {
    return dispatch => {
        localStorage.removeItem('ftf-token');
        dispatch(setAuthorizationStatus(false));
    }
};

export const getUserData = () => {
    let url = host + api.cabinet.user;

    return dispatch => {
        dispatch(getUserDataStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getUserDataSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getUserDataFailure(err));
                if (err?.response?.status === 401){
                    localStorage.removeItem('ftf-token');
                    dispatch(setAuthorizationStatus(false));
                }
            });
    };
};

const getUserDataStarted = () => ({
    type: GET_USER_DATA_STARTED
});

export const getUserDataSuccess = serverReport => ({
    type: GET_USER_DATA_SUCCESS,
    payload: serverReport
});

export const getUserDataFailure = error => ({
    type: GET_USER_DATA_FAILURE,
    payload: error
});


export const getEvents = () => {
    let url = host + api.cabinet.events;

    return dispatch => {
        dispatch(getEventsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getEventsSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getEventsFailure(err));
            });
    };
};

const getEventsStarted = () => ({
    type: GET_EVENTS_STARTED
});

export const getEventsSuccess = serverReport => ({
    type: GET_EVENTS_SUCCESS,
    payload: serverReport
});

export const getEventsFailure = error => ({
    type: GET_EVENTS_FAILURE,
    payload: error
});


export const choiceEvent = (id, navigationCallback) => {
    let url = host + api.cabinet.choiceEvent;

    return dispatch => {
        dispatch(choiceEventStarted());
        axios.put(url, {event_id: id}, headWT())
            .then(res => {
                dispatch(choiceEventSuccess(res.data.response));
                dispatch(getUserData());
                navigationCallback();
            })
            .catch(err => {
                dispatch(choiceEventFailure(err));
            });
    };
};

const choiceEventStarted = () => ({
    type: CHOICE_EVENT_STARTED
});

export const choiceEventSuccess = serverReport => ({
    type: CHOICE_EVENT_SUCCESS,
    payload: serverReport
});

export const choiceEventFailure = error => ({
    type: CHOICE_EVENT_FAILURE,
    payload: error
});


export const getCabinetMainData = () => {
    let url = host + api.cabinet.mainData;

    return dispatch => {
        dispatch(getCabinetMainDataStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getCabinetMainDataSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getCabinetMainDataFailure(err));
            });
    };
};

const getCabinetMainDataStarted = () => ({
    type: GET_CABINET_MAIN_DATA_STARTED
});

export const getCabinetMainDataSuccess = serverReport => ({
    type: GET_CABINET_MAIN_DATA_SUCCESS,
    payload: serverReport
});

export const getCabinetMainDataFailure = error => ({
    type: GET_CABINET_MAIN_DATA_FAILURE,
    payload: error
});


export const getCurrentEvent = (id) => {
    let url = host + api.cabinet.events + `/${id}`;

    return dispatch => {
        dispatch(getCurrentEventStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getCurrentEventSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getCurrentEventFailure(err));
            });
    };
};

const getCurrentEventStarted = () => ({
    type: GET_CURRENT_EVENT_STARTED
});

export const getCurrentEventSuccess = serverReport => ({
    type: GET_CURRENT_EVENT_SUCCESS,
    payload: serverReport
});

export const getCurrentEventFailure = error => ({
    type: GET_CURRENT_EVENT_FAILURE,
    payload: error
});


export const getRoadmap = () => {
    let url = host + api.cabinet.roadmap;

    return dispatch => {
        dispatch(getRoadmapStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getRoadmapSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getRoadmapFailure(err));
            });
    };
};

const getRoadmapStarted = () => ({
    type: GET_ROADMAP_STARTED
});

export const getRoadmapSuccess = serverReport => ({
    type: GET_ROADMAP_SUCCESS,
    payload: serverReport
});

export const getRoadmapFailure = error => ({
    type: GET_ROADMAP_FAILURE,
    payload: error
});


// params: {period: 'all' | 'month' | 'week', type: 'referral'} — фильтры лидерборда
export const getLeaderboard = (params = {}) => {
    const query = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
    let url = host + api.cabinet.leaderboard + (query ? `?${query}` : '');

    return dispatch => {
        dispatch(getLeaderboardStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getLeaderboardSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getLeaderboardFailure(err));
            });
    };
};

const getLeaderboardStarted = () => ({
    type: GET_LEADERBOARD_STARTED
});

export const getLeaderboardSuccess = serverReport => ({
    type: GET_LEADERBOARD_SUCCESS,
    payload: serverReport
});

export const getLeaderboardFailure = error => ({
    type: GET_LEADERBOARD_FAILURE,
    payload: error
});


export const getMatrix = () => {
    let url = host + api.cabinet.matrix;

    return dispatch => {
        dispatch(getMatrixStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getMatrixSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getMatrixFailure(err));
            });
    };
};

const getMatrixStarted = () => ({
    type: GET_MATRIX_STARTED
});

export const getMatrixSuccess = serverReport => ({
    type: GET_MATRIX_SUCCESS,
    payload: serverReport
});

export const getMatrixFailure = error => ({
    type: GET_MATRIX_FAILURE,
    payload: error
});


export const getReferrals = (page, id) => {
    let url = host + api.cabinet.referrals;

    const params = new URLSearchParams();
    if (page != null) params.set("page", page);
    if (id != null && id !== false && id !== "") params.set("lap_id", id);

    const qs = params.toString();
    if (qs) url += `?${qs}`;

    return dispatch => {
        dispatch(getReferralsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReferralsSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getReferralsFailure(err));
            });
    };
};

const getReferralsStarted = () => ({
    type: GET_REFERRALS_STARTED
});

export const getReferralsSuccess = serverReport => ({
    type: GET_REFERRALS_SUCCESS,
    payload: serverReport
});

export const getReferralsFailure = error => ({
    type: GET_REFERRALS_FAILURE,
    payload: error
});

export const resetReferrals = () => ({
    type: RESET_REFERRALS,
    payload: false
});


export const getReferralsMain = () => {
    let url = host + api.cabinet.referralsMain;

    return dispatch => {
        dispatch(getReferralsMainStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReferralsMainSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getReferralsMainFailure(err));
            });
    };
};

const getReferralsMainStarted = () => ({
    type: GET_REFERRALS_MAIN_STARTED
});

export const getReferralsMainSuccess = serverReport => ({
    type: GET_REFERRALS_MAIN_SUCCESS,
    payload: serverReport
});

export const getReferralsMainFailure = error => ({
    type: GET_REFERRALS_MAIN_FAILURE,
    payload: error
});

export const getContestWinners = () => {
    let url = host + api.cabinet.contestWinners;

    return dispatch => {
        dispatch(getContestWinnersStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getContestWinnersSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getContestWinnersFailure(err));
            });
    };
};

const getContestWinnersStarted = () => ({
    type: GET_CONTEST_WINNERS_STARTED
});

export const getContestWinnersSuccess = serverReport => ({
    type: GET_CONTEST_WINNERS_SUCCESS,
    payload: serverReport
});

export const getContestWinnersFailure = error => ({
    type: GET_CONTEST_WINNERS_FAILURE,
    payload: error
});


export const getContestWinnersData = (lap) => {
    let url;

    if (lap){
        url = host + api.cabinet.contestWinnersData + `?lap_order=${lap}`;
    } else {
        url = host + api.cabinet.contestWinnersData;
    }

    return dispatch => {
        dispatch(getContestWinnersDataStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getContestWinnersDataSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getContestWinnersDataFailure(err));
            });
    };
};

const getContestWinnersDataStarted = () => ({
    type: GET_CONTEST_WINNERS_DATA_STARTED
});

export const getContestWinnersDataSuccess = serverReport => ({
    type: GET_CONTEST_WINNERS_DATA_SUCCESS,
    payload: serverReport
});

export const getContestWinnersDataFailure = error => ({
    type: GET_CONTEST_WINNERS_DATA_FAILURE,
    payload: error
});


export const setRefCode = (refCode) => {
    let url= host + api.cabinet.refCode + `?referral_code=${refCode}`;


    return dispatch => {
        dispatch(setRefCodeStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(setRefCodeSuccess(res.data.response));
                dispatch(getReferralsMain());
            })
            .catch(err => {
                dispatch(setRefCodeFailure(err));
            });
    };
};

const setRefCodeStarted = () => ({
    type: SET_REF_CODE_STARTED
});

export const setRefCodeSuccess = serverReport => ({
    type: SET_REF_CODE_SUCCESS,
    payload: serverReport
});

export const setRefCodeFailure = error => ({
    type: SET_REF_CODE_FAILURE,
    payload: error
});


export const sendConnectedWallet = (connectedWallet) => {
    let url= host + api.cabinet.sendConnectedWallet;


    return dispatch => {
        dispatch(sendConnectedWalletStarted());
        axios.put(url, {wallet: connectedWallet}, headWT())
            .then(res => {
                dispatch(sendConnectedWalletSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(sendConnectedWalletFailure(err));
            });
    };
};

const sendConnectedWalletStarted = () => ({
    type: SEND_CONNECTED_WALLET_STARTED
});

export const sendConnectedWalletSuccess = serverReport => ({
    type: SEND_CONNECTED_WALLET_SUCCESS,
    payload: serverReport
});

export const sendConnectedWalletFailure = error => ({
    type: SEND_CONNECTED_WALLET_FAILURE,
    payload: error
});


export const getTokenCourse = () => {
    let url= host + api.cabinet.tokenCourse;


    return dispatch => {
        dispatch(getTokenCourseStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getTokenCourseSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getTokenCourseFailure(err));
            });
    };
};

const getTokenCourseStarted = () => ({
    type: GET_TOKEN_COURSE_STARTED
});

export const getTokenCourseSuccess = serverReport => ({
    type: GET_TOKEN_COURSE_SUCCESS,
    payload: serverReport
});

export const getTokenCourseFailure = error => ({
    type: GET_TOKEN_COURSE_FAILURE,
    payload: error
});


export const sendWalletAfterTransaction = (transactionWallet) => {
    let url= host + api.cabinet.sendWalletAT;


    return dispatch => {
        dispatch(sendWalletAfterTransactionStarted());
        axios.post(url, {wallet: transactionWallet}, headWT())
            .then(res => {
                dispatch(sendWalletAfterTransactionSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(sendWalletAfterTransactionFailure(err));
            });
    };
};

const sendWalletAfterTransactionStarted = () => ({
    type: SEND_WALLET_AFTER_TRANSACTION_STARTED
});

export const sendWalletAfterTransactionSuccess = serverReport => ({
    type: SEND_WALLET_AFTER_TRANSACTION_SUCCESS,
    payload: serverReport
});

export const sendWalletAfterTransactionFailure = error => ({
    type: SEND_WALLET_AFTER_TRANSACTION_FAILURE,
    payload: error
});


export const getReceiveUsdtWallet = () => {
    let url= host + api.cabinet.receiveUsdtWallet;


    return dispatch => {
        dispatch(getReceiveUsdtWalletStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReceiveUsdtWalletSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getReceiveUsdtWalletFailure(err));
            });
    };
};

const getReceiveUsdtWalletStarted = () => ({
    type: GET_RECEIVE_USDT_WALLET_STARTED
});

export const getReceiveUsdtWalletSuccess = serverReport => ({
    type: GET_RECEIVE_USDT_WALLET_SUCCESS,
    payload: serverReport
});

export const getReceiveUsdtWalletFailure = error => ({
    type: GET_RECEIVE_USDT_WALLET_FAILURE,
    payload: error
});


export const getContestInfo = () => {
    let url= host + api.cabinet.contestInfo;


    return dispatch => {
        dispatch(getContestInfoStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getContestInfoSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getContestInfoFailure(err));
            });
    };
};

const getContestInfoStarted = () => ({
    type: GET_CONTEST_INFO_STARTED
});

export const getContestInfoSuccess = serverReport => ({
    type: GET_CONTEST_INFO_SUCCESS,
    payload: serverReport
});

export const getContestInfoFailure = error => ({
    type: GET_CONTEST_INFO_FAILURE,
    payload: error
});


export const changePassword = (data) => {
    let url= host + api.cabinet.changePassword;


    return dispatch => {
        dispatch(changePasswordStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(changePasswordSuccess(res.data.success));
            })
            .catch(err => {
                dispatch(changePasswordFailure(err.response.data.errors));
            });
    };
};

const changePasswordStarted = () => ({
    type: CHANGE_PASSWORD_STARTED
});

export const changePasswordSuccess = serverReport => ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload: serverReport
});

export const changePasswordFailure = error => ({
    type: CHANGE_PASSWORD_FAILURE,
    payload: error
});


export const changeAvatar = (data) => {
    const token = localStorage.getItem('ftf-token');
    let url= host + api.cabinet.changeAvatar;


    return dispatch => {
        dispatch(changeAvatarStarted());
        axios.post(url, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
            .then(res => {
                dispatch(changeAvatarSuccess(res.data.success));
                dispatch(getUserData());
            })
            .catch(err => {
                dispatch(changeAvatarFailure(err.response.data.errors));
            });
    };
};

const changeAvatarStarted = () => ({
    type: CHANGE_AVATAR_STARTED
});

export const changeAvatarSuccess = serverReport => ({
    type: CHANGE_AVATAR_SUCCESS,
    payload: serverReport
});

export const changeAvatarFailure = error => ({
    type: CHANGE_AVATAR_FAILURE,
    payload: error
});


// period: {from: 'YYYY-MM-DD', to: 'YYYY-MM-DD'} — уходит как date_from / date_to
export const getTransactions = (category, page = 1, period = {}) => {
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    if (page) params.set('page', String(page));
    if (period?.from) params.set('date_from', period.from);
    if (period?.to) params.set('date_to', period.to);

    const url = host + api.cabinet.transactions + (params.toString() ? `?${params}` : '');

    return (dispatch) => {
        dispatch(getTransactionsStarted({ page }));
        axios
            .get(url, headWT())
            .then((res) => {
                dispatch(getTransactionsSuccess(res.data.response, page));
            })
            .catch((err) => {
                dispatch(getTransactionsFailure(err?.response?.data?.errors || err?.message));
            });
    };
};

const getTransactionsStarted = (meta) => ({
    type: GET_TRANSACTIONS_STARTED,
    meta, // meta.page
});

export const getTransactionsSuccess = (serverReport, page) => ({
    type: GET_TRANSACTIONS_SUCCESS,
    payload: serverReport,
    meta: { page },
});

export const getTransactionsFailure = (error) => ({
    type: GET_TRANSACTIONS_FAILURE,
    payload: error,
});

export const setBuyRequest = (currency, data) => {
    let url= host + api.cabinet.buyRequest + `/${currency}`;


    return dispatch => {
        dispatch(setBuyRequestStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(setBuyRequestSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(setBuyRequestFailure(err.response.data.errors));
            });
    };
};

const setBuyRequestStarted = () => ({
    type: SET_BUY_REQUEST_STARTED
});

export const setBuyRequestSuccess = serverReport => ({
    type: SET_BUY_REQUEST_SUCCESS,
    payload: serverReport
});

export const setBuyRequestFailure = error => ({
    type: SET_BUY_REQUEST_FAILURE,
    payload: error
});


export const setBuyRequestConfirm = (id) => {
    let url= host + api.cabinet.buyRequest + `/${id}/mark-as-pending`;


    return dispatch => {
        dispatch(setBuyRequestConfirmStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(setBuyRequestConfirmSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(setBuyRequestConfirmFailure(err.response.data.errors));
            });
    };
};

const setBuyRequestConfirmStarted = () => ({
    type: SET_BUY_REQUEST_CONFIRM_STARTED
});

export const setBuyRequestConfirmSuccess = serverReport => ({
    type: SET_BUY_REQUEST_CONFIRM_SUCCESS,
    payload: serverReport
});

export const setBuyRequestConfirmFailure = error => ({
    type: SET_BUY_REQUEST_CONFIRM_FAILURE,
    payload: error
});


export const setBuyRequestCancel = (id) => {
    let url= host + api.cabinet.buyRequest + `/${id}/close`;


    return dispatch => {
        dispatch(setBuyRequestCancelStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(setBuyRequestCancelSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(setBuyRequestCancelFailure(err.response.data.errors));
            });
    };
};

const setBuyRequestCancelStarted = () => ({
    type: SET_BUY_REQUEST_CANCEL_STARTED
});

export const setBuyRequestCancelSuccess = serverReport => ({
    type: SET_BUY_REQUEST_CANCEL_SUCCESS,
    payload: serverReport
});

export const setBuyRequestCancelFailure = error => ({
    type: SET_BUY_REQUEST_CANCEL_FAILURE,
    payload: error
});


export const getDepositLink = (data, closeModal) => {
    let url= host + api.cabinet.depositLink;


    return dispatch => {
        dispatch(getDepositLinkStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(getDepositLinkSuccess(res.data.response));
                closeModal();
            })
            .catch(err => {
                dispatch(getDepositLinkFailure(err?.response?.data?.errors));
            });
    };
};

const getDepositLinkStarted = () => ({
    type: GET_DEPOSIT_LINK_STARTED
});

export const getDepositLinkSuccess = serverReport => ({
    type: GET_DEPOSIT_LINK_SUCCESS,
    payload: serverReport
});

export const getDepositLinkFailure = error => ({
    type: GET_DEPOSIT_LINK_FAILURE,
    payload: error
});


export const getGoogleConnectQr = () => {
    let url= host + api.cabinet.getGoogleQr;


    return dispatch => {
        dispatch(getGoogleConnectQrStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(getGoogleConnectQrSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getGoogleConnectQrFailure(err.response.data.errors));
            });
    };
};

const getGoogleConnectQrStarted = () => ({
    type: GET_GOOGLE_CONNECT_QR_STARTED
});

export const getGoogleConnectQrSuccess = serverReport => ({
    type: GET_GOOGLE_CONNECT_QR_SUCCESS,
    payload: serverReport
});

export const getGoogleConnectQrFailure = error => ({
    type: GET_GOOGLE_CONNECT_QR_FAILURE,
    payload: error
});

export const setGoogleCode = (data, toastHandler) => {
    let url= host + api.cabinet.setGoogleCode;


    return dispatch => {
        dispatch(setGoogleCodeStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(setGoogleCodeSuccess(res.data.response));
                dispatch(getUserData());
                toastHandler();
            })
            .catch(err => {
                dispatch(setGoogleCodeFailure(err.response.data.errors));
            });
    };
};

const setGoogleCodeStarted = () => ({
    type: SET_GOOGLE_CODE_STARTED
});

export const setGoogleCodeSuccess = serverReport => ({
    type: SET_GOOGLE_CODE_SUCCESS,
    payload: serverReport
});

export const setGoogleCodeFailure = error => ({
    type: SET_GOOGLE_CODE_FAILURE,
    payload: error
});


export const sellToken = (data, toastHandler) => {
    let url= host + api.cabinet.sellTokens;


    return dispatch => {
        dispatch(sellTokenStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(sellTokenSuccess(res.data.response));
                dispatch(getMatrix());
                dispatch(getUserData());
                toastHandler();
            })
            .catch(err => {
                dispatch(sellTokenFailure(err.response.data.errors));
            });
    };
};

const sellTokenStarted = () => ({
    type: SELL_TOKENS_STARTED
});

export const sellTokenSuccess = serverReport => ({
    type: SELL_TOKENS_SUCCESS,
    payload: serverReport
});

export const sellTokenFailure = error => ({
    type: SELL_TOKENS_FAILURE,
    payload: error
});


export const withdraw = (data, toastHandler, otpHandler) => {
    let url= host + api.cabinet.mainWithdraw;


    return dispatch => {
        dispatch(withdrawStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(withdrawSuccess(res));
                dispatch(getUserData());
                toastHandler();
            })
            .catch(err => {
                dispatch(withdrawFailure(err?.response?.data?.errors));
                if (err?.response?.data?.errors?.otp && otpHandler){
                    otpHandler();
                }
            });
    };
};

const withdrawStarted = () => ({
    type: WITHDRAW_STARTED
});

export const withdrawSuccess = serverReport => ({
    type: WITHDRAW_SUCCESS,
    payload: serverReport
});

export const withdrawFailure = error => ({
    type: WITHDRAW_FAILURE,
    payload: error
});


export const getWalletHistory = () => {
    let url= host + api.cabinet.walletHistory;


    return dispatch => {
        dispatch(getWalletHistoryStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getWalletHistorySuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getWalletHistoryFailure(err?.response?.data));
            });
    };
};

const getWalletHistoryStarted = () => ({
    type: GET_WALLET_HISTORY_STARTED
});

export const getWalletHistorySuccess = serverReport => ({
    type: GET_WALLET_HISTORY_SUCCESS,
    payload: serverReport
});

export const getWalletHistoryFailure = error => ({
    type: GET_WALLET_HISTORY_FAILURE,
    payload: error
});


export const getReferralAwards = () => {
    let url= host + api.cabinet.referralAwards;


    return dispatch => {
        dispatch(getReferralAwardsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReferralAwardsSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getReferralAwardsFailure(err?.response?.data));
            });
    };
};

const getReferralAwardsStarted = () => ({
    type: GET_REFERRAL_AWARDS_STARTED
});

export const getReferralAwardsSuccess = serverReport => ({
    type: GET_REFERRAL_AWARDS_SUCCESS,
    payload: serverReport
});

export const getReferralAwardsFailure = error => ({
    type: GET_REFERRAL_AWARDS_FAILURE,
    payload: error
});


export const getResetCode = (data) => {
    let url= host + api.main.getResCode;


    return dispatch => {
        dispatch(getResetCodeStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(getResetCodeSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getResetCodeFailure(err?.response?.data?.errors));
            });
    };
};

const getResetCodeStarted = () => ({
    type: GET_RESET_CODE_STARTED
});

export const getResetCodeSuccess = serverReport => ({
    type: GET_RESET_CODE_SUCCESS,
    payload: serverReport
});

export const getResetCodeFailure = error => ({
    type: GET_RESET_CODE_FAILURE,
    payload: error
});



// ===== Привязка Telegram для уведомлений (страница настроек) =====
// Ответы: { response: { linked, username, linked_at } } / { response: { url, expires_at } }
export const telegramApi = {
    status: () => axios.get(host + api.cabinet.telegram, headWT()).then(res => res.data.response),
    link: () => axios.post(host + api.cabinet.telegramLink, {}, headWT()).then(res => res.data.response),
    unlink: () => axios.delete(host + api.cabinet.telegram, headWT()).then(res => res.data.response),
};


// ===== Профиль: никнейм, настройки уведомлений, удаление аккаунта =====
// Ошибки валидации (422) пробрасываются как есть: err.response.data.errors
export const profileApi = {
    changeUsername: (username) => axios.put(host + api.cabinet.changeUsername, {username}, headWT()).then(res => res.data),
    getNotifySettings: () => axios.get(host + api.cabinet.notifySettings, headWT()).then(res => res.data.response),
    // частичное обновление: можно передать только изменённые ключи
    setNotifySettings: (patch) => axios.put(host + api.cabinet.notifySettings, patch, headWT()).then(res => res.data.response),
    // axios.delete передаёт тело через config.data
    deleteAccount: (data) => axios.delete(host + api.cabinet.profile, {...headWT(), data}).then(res => res.data),
};

// ===== In-app уведомления (колокольчик) =====
export const notificationsApi = {
    list: (page = 1) => axios.get(`${host}${api.cabinet.notifications}?page=${page}`, headWT()).then(res => res.data.response),
    unreadCount: () => axios.get(`${host}${api.cabinet.notifications}/unread-count`, headWT()).then(res => res.data.response?.unread_count ?? 0),
    read: (id) => axios.post(`${host}${api.cabinet.notifications}/${id}/read`, {}, headWT()),
    readAll: () => axios.post(`${host}${api.cabinet.notifications}/read-all`, {}, headWT()),
    remove: (id) => axios.delete(`${host}${api.cabinet.notifications}/${id}`, headWT()),
};
